import {Component, Input, OnInit} from '@angular/core';
import {PartnerProduct} from "../../models/partner-product.model";
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";

@Component({
  selector: 'app-partner-product-details',
  templateUrl: './partner-product-details.component.html',
  styleUrls: ['./partner-product-details.component.scss'],
})
export class PartnerProductDetailsComponent implements OnInit {

  @Input()
  partnerProduct: PartnerProduct;
  title: any;
  @Input()
  isGeneralAdmin: boolean;

  constructor(private modalController: ModalController, private commonUtils: CommonUtils) {
  }

  ngOnInit() {
  }

  onClose() {
    this.modalController.dismiss();
  }

  onCopyName() {
    const csvData = `${this.partnerProduct.uuid},${this.partnerProduct.partnerSystemId},${this.partnerProduct.name}`;
    navigator.clipboard.writeText(csvData).then(() => {
      this.commonUtils.presentInfoToast('Dane skopiowane do schowka')

    }).catch(err => {
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas kopiowania')
    });
  }
}
